const hi = {
  //Breadcrumb
  home: "होम",
  aboutUs: "हमारे बारे में",
  products: "उत्पाद",
  research: "अनुसंधान",
  infrastructure: "बुनियादी ढांचा",
  network: "नेटवर्क",
  store: "स्टोर",
  careers: "करियर",
  reachUs: "संपर्क करें",
  dashboard: "डैशबोर्ड",
  cropBook: "फसल बुक",
  search: "खोजें",
  blog: "ब्लॉग",
  cart: "कार्ट",
  login: "लॉगिन",
  privacyPolicy: "गोपनीयता नीति",
  termOfUse: "उपयोग की शर्तें",
  disclaimer: "अस्वीकरण",
  cancellationAndRefund: "रद्दीकरण और धनवापसी",
  shippingAndDelivery: "शिपिंग और डिलीवरी",

  //Menu Page
  OurProducts: "हमारे उत्पाद",
  OurProductsDescription: "हमारे शोध-समर्थित, उच्च उपज वाले बीजों की श्रृंखला देश भर के विभिन्न कृषि-जलवायु क्षेत्रों की सटीक फसल विकास आवश्यकताओं को पूरा करने के लिए विकसित की गई है, जिससे किसानों को सर्वोत्तम परिणाम प्राप्त होते हैं।",
  // Home Page
  ViewDetailsButton: "विवरण देखें",
  YashodaAtAGlanceHeading: "विवरण देखें",
  ExploreCategoryButton: "श्रेणी का अन्वेषण करें",
  KnowMoreButton: "अधिक जानते हैं", 
  BuyOnlineButton: "ऑनलाइन खरीदें",
  NetworkHead: "हमारा पूरा नेटवर्क देखने के लिए कृपया अपना संपर्क नंबर साझा करें",
  ExploreOurNetworkButton: "हमारे नेटवर्क का अन्वेषण करें",
  JobOpenings: "नौकरी की रिक्तियां",
  TeamStrength: "200+ टीम की ताकत",
  TeamMembers: "50+ टीम सदस्य पिछले 10+ वर्षों से हमारे साथ काम कर रहे हैं",
  Experience: "अनुभव",
  ExploreOpportunities: "अवसरों का अन्वेषण करें",
  LifeYashoda: "जीवन @ यशोदा सीड्स",
  FarmersConnectedHead: "किसान जुड़े",
  FarmersConnectButton: "किसान जुड़ें",
  ExploreMoreButton: "और ज्यादा खोजें",

  //about us
  YearExperience: "वर्षों का<br />अनुभव",
  MissionVission: "हमारा मिशन <br/>और विजन",
  ourHistory: "हमारा इतिहास",
  ChairmanDesk: "अध्यक्ष की मेज से",
  //NetworkPage 
  PartnerHead: "हमारे सहयोगियों",
  DealerHead: "क्या आप हमारे डीलर बनना चाहते हैं?",
  DealerBtn: "हमारे साथ जुड़ें",
  
  //Form Field
  FormHead: "कोई प्रश्न है? संपर्क करें!",
  FirstName: "पहला नाम",
  LastName: "उपनाम",
  PhoneNo: "फोन नंबर",
  Email: "ईमेल",
  Message: "संदेश",
  SubmitButton: "जमा करें",
  FullName: "पूर्ण नाव",
  Address: "पता",
  City: "शहर",
  PinCode: "पिनकोड",
  //Contact page
  Call: "हमें कॉल करें",
  Mail: "हमें मेल करें",
  loc: "जगह",
  HaveEnquiries: "कोई पूछताछ है?",
  //Product
  Description: "विवरण",
  Specifications: "विशेष विवरण",
  EnquireNowButton: "अब पूछताछ करें",
  ViewSpecificationsButton: "विशिष्टताएँ देखें",
  //Product Details Page
  MRP: "एमआरपी",
  Weight: "वज़न",
  Quantity: "मात्रा",
  OutOfStock: "स्टॉक ख़त्म",
  Description: "विवरण",
  AddToCart: "कार्ट में जोड़ें",
  EnquiryNowButton: "अभी पूछताछ करें",
  RelatedProducts: "संबंधित उत्पाद",
  OthersCategory: "अन्य श्रेणी",
  //Store Page
  Filters: "फिल्टर",
  Category: "वर्ग",
  LoadMore: "और लोड करें",
  NoProductsFound: "दिखाने के लिए कोई उत्पाद नहीं मिला.",
  //Cart Page
  Cart: "कार्ट",
  Checkout: "चेक आउट",
  Payment: "भुगतान",
  Price: "कीमत",
  Total: "कुल",
  Code: "कोड",
  DeliveryCharges: "वितरण शुल्क",
  DeliveryChargesNote: "यदि कुल राशि 700 से कम है तो आपको डिलीवरी शुल्क का भुगतान करना होगा",
  Subtotal: "उप-योग",
  ContinueShoppingButton: "खरीदारी जारी रखें",
  CheckoutButton: "चेक आउट",
  YourCartIsEmpty: "आपका कार्ट खाली आहे",
  //Checkout Page
  AddAddress: "पता जोड़ें",
  Close: "बंद करना",
  PleaseLoginToCheckout: "कृपया चेकआउट करने के लिए लॉगिन करें।",
  LoginHere: "यहां लॉगिन करें",
  PayNow: "अब भुगतान करें",
  OrderSummery: "आदेश सारांश",
  Note: "टिप्पणी",
  DoNotRefreshOrClose: "किसी भी चालू लेनदेन के दौरान इस पृष्ठ को रीफ़्रेश या बंद न करें। ऐसा करने से डुप्लिकेट शुल्क लग सकते हैं या लेनदेन विफल हो सकता है।",
  AddYourAddressDetails: "अपना पता विवरण जोड़ें",
  //Footer
  FeelFreeToCallUs: "हमें कॉल करने के लिए स्वतंत्र रहें",
  OfficeLocation: "कार्यालय स्थान",
  DropUsAnEmail: "हमें एक ईमेल भेजें",
  ConnectWithUs: "हमसे जुड़ें",
  //Dashboard Page
  MyOrders: "मेरे आदेश",
  Wishlist: "इच्छा-सूची",
  MyAccount: "मेरा खाता",
  Logout: "लॉग आउट",
  ViewOrder: "आर्डर देखें",
  ID: "आदेश कामतत्व",
  Date: "तारीख",
  Total: "कुल",
  Status: "स्थिति",
  ViewOrder: "आर्डर देखें",
  DownloadInvoice: "चालान डाउनलोड करें",
  OrderReceived: "आदेश प्राप्त हुआ",
  OrderProcessing: "आदेश प्रसंस्करण",
  OrderDispatch: "आदेश प्रेषण",
  OrderDeliver: "ऑर्डर वितरित करें",
  Paymentprocessing: "भुगतान प्रसंस्करण",
  Unknownstatus: "अज्ञात स्थिति",
  SlNo: "क्रमांक",
  Item: "वस्तु",
  image: "छवि",
  //logout  
  AreYouSure: "क्या आप सुनिश्चित हैं?",
  Logout: "लॉग आउट!",
  Cancel: "रद्द करें",
  //Login Pop up

  //SEO
  Best: "श्रेष्ठ",
  BuyNowButton: "अभी खरीदें",
};

export default hi;